import { DecimalSchema } from "../../decimal";
import { z } from "zod";

// Season Response DTO
export const HallOfFameSeasonSchema = z.object({
  id: z.uuid(),
  index: z.number().int().nonnegative(),
  name: z.string().min(1),
  startDate: z.coerce.date(),
  endDate: z.coerce.date(),
});
export type HallOfFameSeason = z.infer<typeof HallOfFameSeasonSchema>;

// Top 50 Record Item DTO
export const HallOfFameRecordItemSchema = z.object({
  rank: z.number().int().positive(),
  defiAddress: z.string().min(1),
  tradedVolumeUSD: DecimalSchema,
  isAmbassador: z.boolean().optional().default(false),
});
export type HallOfFameRecordItem = z.infer<typeof HallOfFameRecordItemSchema>;

// Get Seasons Response DTO
export const GetSeasonsResponseSchema = z.array(HallOfFameSeasonSchema);
export type GetSeasonsResponse = z.infer<typeof GetSeasonsResponseSchema>;

// Get Top 50 Response DTO
export const GetTop50ResponseSchema = z.array(HallOfFameRecordItemSchema);
export type GetTop50Response = z.infer<typeof GetTop50ResponseSchema>;

// Get User Rank Data Response DTO
export const GetUserRankDataResponseSchema = z.object({
  userRank: z.number().int().positive().nullable(),
  tradedVolumeUSD: DecimalSchema.nullable(),
  totalParticipants: z.number().int().nonnegative(),
  top50: GetTop50ResponseSchema,
});
export type GetUserRankDataResponse = z.infer<typeof GetUserRankDataResponseSchema>;

// Create Season Request DTO
export const CreateSeasonRequestSchema = z
  .object({
    name: z.string().min(1),
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
  })
  .refine((data) => data.startDate < data.endDate, {
    message: "startDate must be before endDate",
    path: ["endDate"],
  });
export type CreateSeasonRequestDto = z.infer<typeof CreateSeasonRequestSchema>;

// Create Season Response DTO
export const CreateSeasonResponseSchema = HallOfFameSeasonSchema;
export type CreateSeasonResponse = z.infer<typeof CreateSeasonResponseSchema>;

// Compute Season Records Request DTO
export const ComputeSeasonRecordsRequestSchema = z.object({
  seasonIds: z.array(z.uuid()),
});
export type ComputeSeasonRecordsRequestDto = z.infer<typeof ComputeSeasonRecordsRequestSchema>;

// Compute Season Records Response DTO
export const ComputeSeasonRecordsResponseSchema = z.object({
  processedSeasons: z.number().int().nonnegative(),
  totalRecordsUpserted: z.number().int().nonnegative(),
});
export type ComputeSeasonRecordsResponse = z.infer<typeof ComputeSeasonRecordsResponseSchema>;

export const HallOfFameCountdownRewardsResponseSchema = z.object({
  rewards: z.array(
    z.object({
      day: z.number().int().nonnegative(),
      rewardType: z.enum(["discord", "bamboo_key", "golden_key"]),
      rewardLabel: z.string(),
    }),
  ),
  currentDay: z.number().int().nonnegative().nullable(),
});
export type HallOfFameCountdownRewardsResponse = z.infer<typeof HallOfFameCountdownRewardsResponseSchema>;
